// src/screens/ItemManagementScreen.jsx
import productImage from "../../assets/burger.jpg";

const ItemManagementScreen = () => {
  return (
    <div className="p-4 space-y-4">
      <h2 className="text-lg font-semibold">Manage Items</h2>
      <div className="space-y-2">
        {[...Array(3)].map((_, i) => (
          <div key={i} className="flex items-center justify-between border-b py-2">
            <div className="flex items-center gap-4">
              <img src={productImage} alt="product" className="w-12 h-12 rounded" />
              <div>
                <p className="font-medium">Product {i + 1}</p>
                <p className="text-sm text-gray-500">Qty: 1</p>
              </div>
            </div>
            <span className="text-gray-800 font-semibold">₹100</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ItemManagementScreen;
